<div class="auth-shell">
  <div class="auth-card">
    <div class="auth-brand">
      <img src="assets/img/logo.png" class="auth-brand-mark" alt="">
      <span class="auth-brand-word">Fusion</span>
    </div>

    <div class="auth-body">
      @if (sent) {
        <h2 class="auth-title">{{ 'AUTH.FORGOT_SENT_TITLE' | translate }}</h2>
        <!-- Deliberately says nothing about whether the address was recognised. -->
        <p class="auth-lede">{{ 'AUTH.FORGOT_SENT_LEDE' | translate }}</p>
        <div class="auth-links"><a routerLink="/login">{{ 'AUTH.BACK_TO_SIGN_IN' | translate }}</a></div>
      } @else {
        <h2 class="auth-title">{{ 'AUTH.FORGOT_TITLE' | translate }}</h2>
        <p class="auth-lede">{{ 'AUTH.FORGOT_LEDE' | translate }}</p>

        @if (errorKeys.length) {
          <div class="alert alert-danger">
            @for (key of errorKeys; track key) { <div>{{ key | translate }}</div> }
          </div>
        }

        <form (ngSubmit)="submit()" #forgotForm="ngForm">
          <div class="form-group">
            <label for="username">{{ 'USER.USERNAME' | translate }}</label>
            <input type="email" class="form-control" id="username" name="username"
                   [(ngModel)]="username" autocomplete="username" required #usernameField="ngModel">
          </div>
          <div class="auth-actions">
            <button type="submit" class="btn btn-primary" [disabled]="busy || !forgotForm.form.valid">
              {{ 'AUTH.FORGOT_SUBMIT' | translate }}
            </button>
          </div>
        </form>

        <div class="auth-links"><a routerLink="/login">{{ 'AUTH.BACK_TO_SIGN_IN' | translate }}</a></div>
      }
    </div>
  </div>
</div>
